import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import axiosInstance from "axiosConfig";
import { Toast } from "shared";
import { TOAST_TYPES_ENUM } from "enums";
import { queryClient } from "App";

export interface CloseAssetPayload {
  uuid: string;
  closedAt: string;
  salePrice?: number;
  currencyUuid?: string;
}

export const useCloseAsset = (
  options?: UseMutationOptions<any, Error, CloseAssetPayload>
) => {
  return useMutation({
    ...options,
    mutationKey: ["closeAsset"],
    mutationFn: async ({ uuid, closedAt, salePrice, currencyUuid }: CloseAssetPayload) => {
      return axiosInstance
        .post(`/investments/${uuid}/close`, { 
          closedAt,
          salePrice,
          currencyUuid,
        })
        .then((res) => res.data);
    },
    onMutate: (variables) => {
      Toast({
        message: "Zamykanie aktywa...",
        type: TOAST_TYPES_ENUM.LOADING,
        id: "close-asset",
      });
      if (options?.onMutate) {
        // @ts-ignore
        return options.onMutate(variables);
      }
    },
    onSuccess: (data, variables, context) => {
      queryClient.invalidateQueries({ queryKey: ["investments/grouped"] });
      if (options?.onSuccess) {
        options.onSuccess(data, variables, context);
      }
    },
    onError: (error, variables, context) => {
      Toast({
        message: "Błąd podczas zamykania aktywa.",
        type: TOAST_TYPES_ENUM.ERROR,
        id: "close-asset",
      });
      if (options?.onError) {
        options.onError(error, variables, context);
      }
    },
  });
};
